<template>
  <!-- <div> -->
  <!-- 子明部分 -->
  <!-- <video id="myVideo" ref="video" controls muted preload="auto" class="video-js aliplayer" /> -->
  <!-- hls部分 -->
  <!-- <video id="hlsVedio" controls muted preload="auto" class="video-js aliplayer aliplayer"></video> -->
  <!-- flv部分 -->
  <!-- <video id="myvideo" autoplay muted @click="click" controls width="300" height="300"></video> -->
  <!-- </div> -->
  <!-- 版本1部分 -->
  <div>
    <vue-aliplayer-v2
      id="hlsVedio"
      v-if="Alipshow"
      ref="VueAliplayerV2"
      :options="options"
      class="aliplayer"
    />
    <!-- <div id="video" style="width:100%;"></div> -->
  </div>
</template>

<script>
import flvjs from "flv.js/dist/flv.min.js";
import Hls from "hls.js";
export default {
  name: "realPlay",
  props: ["source"],
  data() {
    return {
      Alipshow: true,
      // 子明部分
      myPlayer: null,
      sourceM3u8: "",
      // 版本1部分
      startAndEndTime: "",
      dialogVisible: true,
      options: {
        source: "",
        isLive: true, //是否直播
        useH5Prism: true, //h5播放器
        disableSeek: true, //是否禁用进度条的Seek
      },
      title: "实时播放",
      autoplay: false,
      // hls部分
      hls: "",
      // flv部分
      player: null,
      playing: false,
      timer: "",
    };
  },
  mounted() {
    // var videoObject = {
    //   container: "#video", //容器的ID或className
    //   variable: "player", //播放函数名称
    //   loop: true, //播放结束是否循环播放
    //   autoplay: true, //是否自动播放
    //   poster: "material/poster.jpg", //封面图片
    //   video: "rtmp://222.173.70.50/vehicle/013520190000-1"
    // };
    // var player = new ckplayer(videoObject);
    // 子明部分
    // this.myVideo = this.$video("myVideo", {
    //   bigPlayButton: true,
    //   textTrackDisplay: false,
    //   posterImage: false,
    //   errorDisplay: false,
    //   hls: {
    //     withCredentials: true,
    //   },
    // });
    // 版本1部分
    // this.options.source = this.source;
  },
  methods: {
    // 销毁
    destroy() {
      this.Alipshow = false;
      this.sourceM3u8 = "";
      if (this.hls) {
        this.hls.destroy();
      }
    },
    //  地址接收
    setSource(e) {
      e = e.videoURL;
      this.options.source =e
      this.Alipshow = true;
      this.sourceM3u8 = String(e);
      // this.initVideo();
      // this.videoHls(this.sourceM3u8);
    },
    // 张子明部分
    // initVideo() {
    //   this.myVideo.src({ type: "rtmp/flv", src: this.sourceM3u8 });
    // },
    // hls部分
    videoHls(e) {
      const video = document.getElementById("hlsVedio");
      if (Hls.isSupported()) {
        const hls = new Hls();
        this.hls = hls;
        hls.loadSource(e);
        hls.attachMedia(video);
        hls.on(Hls.Events.MANIFEST_PARSED, function () {
          video.play();
        });
      } else if (video.canPlayType("rtmp/flv")) {
        video.src = e;
        video.addEventListener("loadedmetadata", function () {
          video.play();
        });
      }
    },
  },
};
</script>
<style scoped lang='scss'>
.line {
  @include line;
}
.input {
  width: 100%;
  overflow: hidden;
}
.aliplayer {
  width: 100% !important;
  height: 400px !important;
}
</style>
<style lang='scss'>
.dialogForm {
  @include dialogForm;
}
</style>










// WEBPACK FOOTER //
// src/components/vueAliplayerV2/realPlay.vue